// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "js/" + chunkId + "-legacy." + {"187":"4e225c13","256":"3c1a8066","644":"1b28eb21","646":"96593974","889":"9c15b92b"}[chunkId] + ".js";
};